import { keepPreviousData, useQuery } from '@tanstack/react-query';
import type { GridFilterModel, GridSortModel } from '@mui/x-data-grid';
import {
  DIAM_API_PATH,
  DiamPageSortField,
  DiamRoleFilter,
  getRolesPage,
} from '../../diamApi';
import { useApiEssentials } from '../../../../shared/hooks/useApiEssentials';
import { buildRolesPageFilter, toDiamSortFields } from '../../diamGridUtils';

export const FUNCTIONAL_ROLES_FILTER: DiamRoleFilter = { type: 'FUNCTIONAL' };

export interface UseRolesPageParams {
  page: number;
  pageSize: number;
  sortModel: GridSortModel;
  filterModel: GridFilterModel;
}

const DEFAULT_SORT: DiamPageSortField[] = [{ field: 'name', direction: 'ASC' }];

export function useRoles({
  page,
  pageSize,
  sortModel,
  filterModel,
}: UseRolesPageParams) {
  const { getIdToken, apiUrl, isSignedIn } = useApiEssentials(DIAM_API_PATH);
  const filter = buildRolesPageFilter(FUNCTIONAL_ROLES_FILTER, filterModel);
  const sort = toDiamSortFields(sortModel, DEFAULT_SORT);

  return useQuery({
    queryKey: ['diam', 'roles', 'page', page, pageSize, sort, filter] as const,
    queryFn: async () => {
      const idToken = await getIdToken();
      return getRolesPage(apiUrl, idToken, {
        page,
        limit: pageSize,
        sort,
        filter,
      });
    },
    enabled: isSignedIn,
    placeholderData: keepPreviousData,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
